"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockDefiPassportFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MockDefiPassportFactory = /** @class */ (function (_super) {
    __extends(MockDefiPassportFactory, _super);
    function MockDefiPassportFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockDefiPassportFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockDefiPassportFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockDefiPassportFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockDefiPassportFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockDefiPassportFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MockDefiPassportFactory;
}(contracts_1.ContractFactory));
exports.MockDefiPassportFactory = MockDefiPassportFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "skin",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "skinTokenId",
                        type: "uint256",
                    },
                ],
                indexed: false,
                internalType: "struct DefiPassportStorage.SkinRecord",
                name: "_skinRecord",
                type: "tuple",
            },
        ],
        name: "ActiveSkinSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_skin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_skinTokenId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "_status",
                type: "bool",
            },
        ],
        name: "ApprovedSkinStatusChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "skin",
                        type: "address",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "tokenId",
                                type: "uint256",
                            },
                            {
                                internalType: "bool",
                                name: "status",
                                type: "bool",
                            },
                        ],
                        internalType: "struct DefiPassportStorage.TokenIdStatus[]",
                        name: "skinTokenIdStatuses",
                        type: "tuple[]",
                    },
                ],
                indexed: false,
                internalType: "struct DefiPassportStorage.SkinAndTokenIdStatusRecord[]",
                name: "_skinsRecords",
                type: "tuple[]",
            },
        ],
        name: "ApprovedSkinsStatusesChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "_baseURI",
                type: "string",
            },
        ],
        name: "BaseURISet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_skin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_skinTokenId",
                type: "uint256",
            },
        ],
        name: "DefaultActiveSkinChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_skin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "_status",
                type: "bool",
            },
        ],
        name: "DefaultSkinStatusChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_skinManager",
                type: "address",
            },
        ],
        name: "SkinManagerSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_skin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "_status",
                type: "bool",
            },
        ],
        name: "WhitelistSkinSet",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "approvedSkins",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultActiveSkin",
        outputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "skin",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "skinTokenId",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "defaultSkins",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256",
            },
        ],
        name: "getActiveSkin",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "skin",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "skinTokenId",
                        type: "uint256",
                    },
                ],
                internalType: "struct DefiPassportStorage.SkinRecord",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name_",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol_",
                type: "string",
            },
            {
                internalType: "address",
                name: "_skinManager",
                type: "address",
            },
        ],
        name: "init",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                internalType: "address",
                name: "_skinContract",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_skinTokenId",
                type: "uint256",
            },
        ],
        name: "isSkinAvailable",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "address",
                name: "_passportSkin",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_skinTokenId",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_skin",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_skinTokenId",
                type: "uint256",
            },
        ],
        name: "setActiveSkin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_skin",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_skinTokenId",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "_status",
                type: "bool",
            },
        ],
        name: "setApprovedSkin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "skin",
                        type: "address",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "tokenId",
                                type: "uint256",
                            },
                            {
                                internalType: "bool",
                                name: "status",
                                type: "bool",
                            },
                        ],
                        internalType: "struct DefiPassportStorage.TokenIdStatus[]",
                        name: "skinTokenIdStatuses",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct DefiPassportStorage.SkinAndTokenIdStatusRecord[]",
                name: "_skinsToApprove",
                type: "tuple[]",
            },
        ],
        name: "setApprovedSkins",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_baseURI",
                type: "string",
            },
        ],
        name: "setBaseURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_skin",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_skinTokenId",
                type: "uint256",
            },
        ],
        name: "setDefaultActiveSkin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_skin",
                type: "address",
            },
            {
                internalType: "bool",
                name: "_status",
                type: "bool",
            },
        ],
        name: "setDefaultSkin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_skinManager",
                type: "address",
            },
        ],
        name: "setSkinManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_skinContract",
                type: "address",
            },
            {
                internalType: "bool",
                name: "_status",
                type: "bool",
            },
        ],
        name: "setWhitelistedSkin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "skinManager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenOfOwnerByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "whitelistedSkins",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
